
import Failure from '@/lib/common/rest/Failure';
import Success from '@/lib/common/rest/Success';
import WithResponse from '@/lib/common/rest/WithResponse';
import { IS_LOCALHOST } from '@/lib/common/IsLocalhost';
import { PROJECT_ID } from '@/lib/util/ProjectConfig';

const REST_PREFIX = IS_LOCALHOST ? `http://localhost:5001/${PROJECT_ID}/us-central1/restApi` : '';
console.log(`REST_PREFIX=${REST_PREFIX}`);

export type RestResponse<T> = (Failure & WithResponse) | (Success<T> & WithResponse);

export const http = <T>(request: RequestInfo): Promise<RestResponse<T>> => {
  //console.log("http request=", request);
  return new Promise<RestResponse<T>>((resolve, reject) => {
    let capturedResponse: Response;
    fetch(request)
      .then(async (response: Response) => {
        capturedResponse = response;
        if ( response.ok ) {
          const jsonParsedBody = (await response.json()) as Failure | Success<T>;
          console.log("jsonParsedBody=", jsonParsedBody);
          resolve({ response, ...jsonParsedBody });
        }
        else {
          reject({
            response,
            responseCode: 4999,
            message: `REST call failed with status code ${response.status}: ${response.statusText}`,
          });
        }
      })
      .catch((err) => {
        reject({
          response: capturedResponse,
          responseCode: 5999,
          message: `${err}`,
        });
      });
  });
};

export const get = async <T>(
  path: string,
  args: RequestInit = { method: "get" }
): Promise<RestResponse<T>> => {
  return await http<T>(new Request(REST_PREFIX + path, args));
};

export const post = async <T>(
  path: string,
  body: any,
  args: RequestInit = { method: "post", body: JSON.stringify(body), headers: new Headers({'content-type': 'application/json'}) }
): Promise<RestResponse<T>> => {
  return await http<T>(new Request(REST_PREFIX + path, args));
};

export const put = async <T>(
  path: string,
  body: any,
  args: RequestInit = { method: "put", body: JSON.stringify(body) }
): Promise<RestResponse<T>> => {
  return await http<T>(new Request(REST_PREFIX + path, args));
};
